const syncWorker = new Worker(new URL('./sync-worker.js', import.meta.url), {
  type: 'module',
})

const stompWorker = new Worker(new URL('./stomp-worker.js', import.meta.url), {
  type: 'module',
})

const uploadWorker = new Worker(new URL('./upload-worker/upload-worker.js', import.meta.url), {
  type: 'module',
})
const userActivityWorker = new Worker(new URL('./user-activity.js', import.meta.url), {
  type: 'module',
})

export default {
  syncWorker,
  stompWorker,
  uploadWorker,
  userActivityWorker,
}
